function formatPhoneNumber(value) {
    if (!value)
        return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4)
        return phoneNumber;
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    else if (phoneNumberLength >= 11 && phoneNumber.slice(0, 1) === '1') {
        return `+${phoneNumber.slice(0, 1)} (${phoneNumber.slice(1, 4)})-${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7, 11)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
const stripFormat = (phoneNumber) => {
    const nonDigitRegex = /[^0-9]/g;
    return phoneNumber.replace(nonDigitRegex, '');
};
function isValidPhoneNumber(phoneNumber) {
    if (!phoneNumber)
        return false;
    // test if it consists of 10 digits
    return /^([1])?\d{10}$/.test(phoneNumber);
}
function isValidSmsCode(smsCode) {
    if (!smsCode)
        return false;
    // test if it consists of 10 digits
    return /^\d{6}$/.test(smsCode);
}
export { formatPhoneNumber, stripFormat, isValidPhoneNumber, isValidSmsCode };
